'use client'
import React, { useCallback, useEffect, useState } from 'react'
import cls from 'classnames'
import styles from './styles.module.scss'
import Mask, { TMaskProps } from '@/components/Mask'
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice'

type TModalProps = {
  phoneWidth?: number
  phonePopup?: 'bottom' | 'fullscreen'
  padWidth?: number
  alignTitle?: 'left' | 'center'
  phoneOnly?: boolean
} & TMaskProps

export default function Modal(props: TModalProps) {
  const [visible, setVisible] = useState(false)
  const responsiveDevice = useResponsiveDevice()

  // 处理props.open的变化的动画
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(props.open ?? true)
    }, 100)
    return () => clearTimeout(timer)
  }, [props.open])

  // 处理props.open的变化的动画

  const handleClose = useCallback(() => {
    setVisible(false)
    setTimeout(() => {
      props.onClose?.()
    }, 200)
  }, [props.onClose])

  if (props.phoneOnly && responsiveDevice !== 'phone') return props.children

  if (!props.open) return null

  let width
  if (responsiveDevice === 'phone' && props.phoneWidth) {
    width = props.phoneWidth
  } else if (responsiveDevice === 'pad' && props.padWidth) {
    width = props.padWidth
  } else if (props.width) {
    width = props.width
  }
  if (props.phonePopup && responsiveDevice === 'phone') {
    width = undefined
  }

  return (
    <Mask
      {...props}
      width={width}
      onClose={handleClose}
      open={visible}
      showCloseBtn={props.showCloseBtn ?? true}
      className={cls(styles.modal, props.className, {
        [styles.fullscreen]: responsiveDevice === 'phone' && props.phonePopup === 'fullscreen',
        [styles.bottom]: responsiveDevice === 'phone' && props.phonePopup === 'bottom',
        [styles.alignCenter]: props.alignTitle === 'center',
      })}
    >
      {props.children}
    </Mask>
  )
}
